import { contacto } from '../data/viajes';

/**
 * Publicación de Instagram lista para la sección de redes (la arma la función de Vercel /api/instagram a partir del
 * feed de Behold).
 * @typedef {Object} PostInstagram
 * @property {string} id
 * @property {string} url     enlace a la publicación en Instagram
 * @property {string} imagen  foto (o portada del video)
 * @property {string} texto   pie recortado (puede ir vacío)
 * @property {'foto'|'video'|'carrusel'} tipo
 * @property {string} fecha   fecha de publicación (ISO 8601)
 */

/** Usuario de TikTok de Jenny, tomado del enlace a su perfil ('experienciasbyjenn'). */
export const TIKTOK_USUARIO = (contacto.tiktok.match(/@([\w.]+)/) || [])[1] || '';

/** Tiempo máximo para leer las publicaciones de Instagram. */
const ESPERA_MS = 6000;
const TIPOS = ['foto', 'video', 'carrusel'];

/**
 * @param {unknown} p
 * @returns {p is PostInstagram}
 */
const esPost = (p) => !!p && typeof p === 'object' &&
  typeof p.id === 'string' && typeof p.texto === 'string' && TIPOS.includes(p.tipo) &&
  typeof p.url === 'string' && /^https:\/\/(www\.)?instagram\.com\//.test(p.url) &&
  typeof p.imagen === 'string' && p.imagen.startsWith('https://');

/**
 * Últimas publicaciones de Instagram de Jenny. Devuelve [] si el feed no está configurado, falla o tarda más de 6 s
 * (también en local con `npm start`, donde no hay /api): la sección muestra entonces las fotos elegidas a mano.
 * @returns {Promise<PostInstagram[]>}
 */
export async function cargarPostsInstagram() {
  const control = new AbortController();
  const reloj = setTimeout(() => control.abort(), ESPERA_MS);
  try {
    const r = await fetch('/api/instagram', { signal: control.signal, headers: { accept: 'application/json' } });
    if (r.status !== 200) return [];
    const datos = await r.json();
    return Array.isArray(datos.posts) ? datos.posts.filter(esPost).slice(0, 6) : [];
  } catch {
    return [];
  } finally {
    clearTimeout(reloj);
  }
}
